import { Component, ElementRef, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { Chart } from 'chart.js';
import { Theme, ThemeService } from '../../theme/theme.service';

@Component({
    selector: 'app-small-pie-chart',
    templateUrl: './small-pie-chart.component.html',
    styleUrls: ['./small-pie-chart.component.scss']
})
export class SmallPieChartComponent implements OnInit, OnChanges {

    @Input() public type: 'pie' | 'doughnut' = 'doughnut';
    @Input() public title: string;
    @Input() public data: number[] = [];
    @Input() public sectionLabels: string[] = [];
    @Input() public sectionColors: string[] = [];

    public chart: Chart;

    @ViewChild('chart', {static: true, read: ElementRef}) private readonly element: ElementRef;

    constructor(private readonly themes: ThemeService) {}

    private darkThemeOptions() {
        return ({
            title: {
                display: this.title !== undefined,
                fontColor: 'white',
                fontSize: 6,
                position: 'bottom',
                padding: 1,
                text: this.title
            },
            legend: {
                display: false
            }
        });
    }

    private lightThemeOptions() {
        return ({
            title: {
                display: this.title !== undefined,
                fontColor: 'black',
                fontSize: 6,
                position: 'bottom',
                padding: 2,
                text: this.title
            },
            legend: {
                display: false
            }
        });
    }

    public ngOnInit(): void {
        this.chart = new Chart(this.element.nativeElement, {
            type: this.type,
            data: {
                labels: this.sectionLabels,
                datasets: this.constructDatasets()
            }
        });

        this.themes.themeChanges.subscribe(this.updateForTheme.bind(this));
    }

    private updateForTheme(theme: Theme) {
        if (theme === Theme.Light) {
            this.chart.options = this.lightThemeOptions();
        } else if (theme === Theme.Dark) {
            this.chart.options = this.darkThemeOptions();
        }
        this.chart.update();
    }

    private constructDatasets() {
        return [
            {
                data: this.data,
                backgroundColor: this.sectionColors ? this.sectionColors : undefined
            }
        ];
    }

    public ngOnChanges(changes: SimpleChanges) {
        if (this.chart && changes) {
            this.chart.data = {
                labels: this.sectionLabels,
                datasets: this.constructDatasets()
            };
            this.chart.update();
        }
    }

}
